export default __webpack_public_path__ + "static/media/tramitecIconLogo.7cecbd56.jpg";